import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import auth from './auth'
import search from './search'
import articles from './articles'
import passwordRestore from './restore-pass'
import verifyEmail from './verify-email'
import admin from './admin'
import passwordUpdate from './password-update'
import stripeState from './stripe'

const rootReducer = combineReducers({
  auth, passwordRestore, passwordUpdate, verifyEmail, search, articles, admin, stripeState,
  routing: routerReducer
})

export default rootReducer
